<template>
  <div class="home">
    <b-container>
      <h1 class="titre_home">Réseau de bus urbain de Neufchâteau</h1>
      <span class="possibilite_express">Fonctionne du mardi au samedi (hors jours fériés)</span>
    </b-container>

    <img class="thermometre_desktop" src="../assets/thermometre-desktop.png" alt="parcours Neobus desktop"/>
    <img class="thermometre_mobile" src="../assets/thermometre-mobile.png" alt="parcours Neobus mobile"/>

    <b-container>
      <span class="titre_tarifs">Tarifs : </span>
      <div>
        <span class="titre_tarifs_alt">Tickets à l'unité : </span>
        <span class="titre_tarifs">1€ </span>
      </div>
      <div>
        <span class="titre_tarifs_alt">Enfant de moins de 6 ans : </span>
        <span class="titre_tarifs">gratuit </span>
      </div>
      <div>
        <span class="titre_tarifs_alt">Carnet de 10 tickets : </span>
        <span class="titre_tarifs">7€</span>
      </div>
    </b-container>

    <b-container>
      <span class="possibilite_express">Achat des titres de transport uniquement à bord des véhicules</span>
    </b-container>

    <b-container>
      <div class="grille row">
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_vert" href="/static/NEOBUS-depliant-2022.pdf" target="_blank">
            <i class="icone far fa-clock fa-4x"></i><br/>
            <span class="text_bloc">Consultez les horaires</span>
          </b-btn>
        </div>
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_bleu" :to="{name:'Arrets'}">
            <i class="icone fas fa-road fa-4x"></i><br/>
            <span class="text_bloc">Prochains passages</span>
          </b-btn>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    }

  }
</script>

<style lang="scss">
@import "src/sass/app";

.home {
  margin-top: 3rem;
  text-align: center;

  .titre_home {
    color: $secondcolor;
    font-family: $titlefont;
    font-size: 50px;
    font-weight: bold;
  }

  .possibilite_express {
    color: $secondcolor;
    font-family: $textfont;
    font-size: 20px;
  }

  .titre_tarifs {
    color: $firstcolor;
    font-family: $textfont;
    font-size: 30px;
  }

  .titre_tarifs_alt {
    color: $secondcolor;
    font-family: $textfont;
    font-size: 30px;
  }

  .accroche {
    margin: 2rem 0;
    font-size: 25px;
    text-align: justify;
    color: $annexecolor;
    font-family: $textfont;
  }

  .thermometre_desktop {
    width: 145vh;
    @include media-breakpoint-down(lg) {
      width: 110vh;
    }
    @include media-breakpoint-down(md) {
      width: 90vh;
    }
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  .thermometre_mobile {
    @include media-breakpoint-up(md) {
      display: none;
    }
    @include media-breakpoint-between(sm, md) {
      width: 69vh;
    }
    @include media-breakpoint-down(xs) {
      width: 55vh;
    }
  }

  .grille {
    margin-top: 2rem;
    display: flex;

    .bloc_vert {
      @include blocHome;
      border: 2px solid $firstcolor;
      background-color: white;
      color: $firstcolor;
    }

    .bloc_vert:hover {
      background-color: $firstcolor;
      color: white;
    }

    .bloc_bleu {
      @include blocHome;
      border: 2px solid $secondcolor;
      background-color: white;
      color: $secondcolor;
    }

    .bloc_bleu:hover {
      background-color: $secondcolor;
      color: white;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue